import { notifyIcon, requestMethod } from "../../../../config";
import envConfig from "../../../../env.config";
import { fetch } from "../../../../shared/services/api.service";
import { checkApiSuccess } from "../../../../utils";
import { getNotification } from "../../../../utils/common";

const TASK_URL = `${envConfig.BASE_URL.BASE_API_URL}/workflow`;

export const addWorkflowDescriptionVariables = async (data) => {
  let requestConfig = {
    method: requestMethod.POST,
    url: `${TASK_URL}/addWorkflowDescriptionVariables`,
    data: data,
  };
  let response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    if (response.data) {
      return response.data.data;
    } else getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
};

export const getWorkflowDescriptionVariables = async (data) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${TASK_URL}/getWorkflowDescriptionVariables`,
    params: data,
  };
  let response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    if (response.data) {
      return response.data.data;
    } else getNotification(response.data.message, notifyIcon.ERROR_ICON);
  }
};
